export default __webpack_public_path__ + "static/media/bird_marker3.dab8849e.png";